import React from "react";
import { services } from "../mock";
import { useLanguage } from "../contexts/LanguageContext";

const Services = () => {
  const { t } = useLanguage();

  return (
    <>
      <section className="mag-services-banner">
        <h2>{t.servicesBanner.title}</h2>
        <div className="mag-underline" />
      </section>
      <section className="mag-services" id="services">
        <div className="mag-services-grid">
          {services.map((service) => {
            const translated = t.services[service.key];
            const label = translated ? translated.name : service.key;
            return (
              <div key={service.id} className="mag-service-card reveal">
                <div className="mag-service-image-wrap">
                  <img
                    src={service.image}
                    alt={label}
                    loading="lazy"
                    decoding="async"
                    className="mag-service-image"
                  />
                </div>
                <div className="mag-service-label">{label}</div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Services;
